import React, { useEffect, useState } from 'react';
import { useSpeech } from '../context/SpeechContext';
import { useAudio } from '../context/AudioContext';
import { useI18n } from '../i18n';
import './AgentWidget.css';

const AgentWidget = ({ inMenu = false }) => {
  const { t } = useI18n();
  const { isListening, startListening, stopListening } = useSpeech();
  const { isSpeaking, isPlaying, stopAll } = useAudio();
  const [isManipulating, setIsManipulating] = useState(false);
  const [isThinking, setIsThinking] = useState(false);

  const isAudioActive = isSpeaking || isPlaying;
  const isAgentActive = isAudioActive || isListening || isThinking;

  const cancelAgentInternals = () => {
    window.dispatchEvent(new CustomEvent('q-agent-cancel', { detail: { source: 'agent-widget' } }));
  };

  const handleClick = () => {
    cancelAgentInternals();
    if (isAgentActive) {
      setIsThinking(false);
      setIsManipulating(false);
      stopAll({ resumeSpeech: false });
      stopListening({ force: true });
      return;
    }
    const started = startListening();
    if (started === false) {
      stopListening({ force: true });
    }
  };

  const getWidgetContent = () => {
    if (isAudioActive) {
      return '■'; // Stop icon
    }
    if (isListening) {
      return '...'; // Listening indicator
    }
    return 'Q';
  };

  const widgetClasses = `
    agent-widget
    ${inMenu ? 'in-menu' : ''}
    ${isManipulating ? 'manipulating' : ''}
    ${isListening ? 'listening' : ''}
    ${isAudioActive ? 'speaking' : ''}
    ${isThinking ? 'thinking' : ''}
  `;

  useEffect(() => {
    let timeoutId;

    const handleManipulate = () => {
      window.clearTimeout(timeoutId);
      setIsManipulating(true);
      document.body.classList.add('q-system-override');

      timeoutId = window.setTimeout(() => {
        setIsManipulating(false);
        document.body.classList.remove('q-system-override');
      }, 650);
    };

    window.addEventListener('q-agent-manipulate', handleManipulate);
    const handleThinking = (event) => setIsThinking(Boolean(event.detail));
    window.addEventListener('q-agent-thinking', handleThinking);

    return () => {
      window.clearTimeout(timeoutId);
      window.removeEventListener('q-agent-manipulate', handleManipulate);
      window.removeEventListener('q-agent-thinking', handleThinking);
      document.body.classList.remove('q-system-override');
    };
  }, []);

  return (
    <div className="agent-widget-container">
      {isThinking && (
        <div className="agent-thinking-badge">
          {t('qoph.thinking') || 'Pensando...'}
        </div>
      )}
      <button className={widgetClasses} onClick={handleClick}>
        {getWidgetContent()}
      </button>
    </div>
  );
};

export default AgentWidget;
